<template>
  <div>
    <el-form ref="formData" :model="formData" size="mini">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.fabric_label_groupSpecName') || '规格名称'"
          >
            <el-input v-model="formData.groupSpecName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.form_label_detail_material_category') || '2级物料分类'
            "
          >
            <el-input
              v-model="formData.detailMaterialCategoryName"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_material_no') || '辅料编号'
            "
          >
            <el-input v-model="formData.materialNo" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.table_label_accessories_name') || '物料名称'"
          >
            <el-input v-model="formData.materialName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.table_label_accessories_specifications') || '辅料规格'
            "
          >
            <el-input v-model="formData.materialSpec" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.table_label_accessories_qty') || '用量'"
          >
            <el-input v-model="formData.qty" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_material_unit') ||
                '物料单位'
            "
          >
            <el-input v-model="formData.v_materialUnit" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_isCommon') || '是否是通用物料'"
          >
            <el-input v-model="formData.v_isCommon" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.order_form_label_isCustomerProvide') || '是否客供'
            "
          >
            <el-input
              v-model="formData.v_isCustomerProvide"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_isSpecify') || '客户指定供应商'"
          >
            <el-input v-model="formData.v_isSpecify" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="
              $l('INDEX.form_label_production_order_is_factory_confirm') ||
                '是否工厂确认'
            "
          >
            <el-input v-model="formData.v_isFactoryConfirm" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.purchase_form_label_scmCode') || '供应商'"
          >
            <el-input v-model="formData.scmName" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('INDEX.batch_label_outBillType') || '出单类型'"
          >
            <el-input v-model="formData.v_outBillType" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_dispatchPort') || '发运港口'
            "
          >
            <el-input v-model="formData.v_dispatchPort" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.order_form_batch_label_destinationPort') || '目的港口'
            "
          >
            <el-input v-model="formData.v_destinationPort" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <TechDocTable :tableData="formData.listDoc" />
      </el-row>
    </el-form>
  </div>
</template>

<script>
import TechDocTable from '../doc-table'
export default {
  components: { TechDocTable },
  props: { orderMaterialCode: { default: '', type: String } },
  data() {
    return {
      formData: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderMaterialCode) return
      this.$api
        .pendingOrderDemandMaterialDetailApi({
          orderMaterialCode: this.orderMaterialCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
